
import {
  saveGiveEntityDetail,
  listDataGiveEntity,
  modifyOpenFlag,
  getGiveEntity,
  deleteGiveEntity,
  queryOrderGiveEntitySendPageData,
  saveOrderGiveEntitySend,
  modifyOrderGiveEntitySendStatus, modifyOrderGiveEntitySendByExcel
} from '@/zsm-api-new/giveEntity.js'
const state = {

}

const mutations = {

}

const actions = {

  /**
   * 保存赠品发货状信息
   * @param id 关联的订单号
   * @param remarks 备注
   * @param sendStatus 发货状态
   * @param teacherMobile 讲师账号
   * @param sendNo 发货单号
   * @param payFlag 支付状态
   * @param goodId 商品id
   * @param orderNo 关联单号
   * @returns {AxiosPromise}
   */

  saveOrderGiveEntitySend({ commit }, id) {
    return new Promise((resolve, reject) => {
      saveOrderGiveEntitySend(id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  /**
   * 查询赠品发货信息分页数据
   * @param teacherMobile 讲师账号
   * @returns {AxiosPromise}
   */
  queryOrderGiveEntitySendPageData({ commit }, id) {
    return new Promise((resolve, reject) => {
      queryOrderGiveEntitySendPageData(id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  /**
   * 删除单个赠送信息
   * @param id 当前附赠实物的id
   * @returns {AxiosPromise}
   */
  deleteGiveEntity({ commit }, id) {
    return new Promise((resolve, reject) => {
      deleteGiveEntity(id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  /**
   * 获取单个赠送信息
   * @param id 当前附赠实物的id
   * @returns {AxiosPromise}
   */
  getGiveEntity({ commit }, id) {
    return new Promise((resolve, reject) => {
      getGiveEntity(id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  /**
   * 修改附赠实物状态
   * @param openFlag  1.开启 0.关闭
   * @param id 当前附赠实物的id
   * @returns {*}
   */
  modifyOpenFlag({ commit }, info) {
    const { openFlag, id } = info
    return new Promise((resolve, reject) => {
      modifyOpenFlag(id, openFlag).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  /**
   * 获取赠品列表
   * @param title  名称
   * @param goodId 商品id
   * @param goodName 商品名称
   * @param openFlag  启用状态 1.开启 0.关闭
   * @param auditFlag   获取场景 1.提交抖音审核 2.不提交
   * @param sendBackPolicyStatus 0：退款不需要退还赠品 1：需要退还赠品
   * @param sendBackPolicyDesc 退款策略描述
   * @param sellGoodGiveEntity 详情内容 images图片   title标题
   * @param pageNo 分页
   * @param pgaeSize 当前页数
   * @returns {*}
   */
  listDataGiveEntity({ commit }, info) {
    return new Promise((resolve, reject) => {
      listDataGiveEntity(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 保存单个赠品信息
   * @param title  名称
   * @param goodId 商品id
   * @param goodName 商品名称
   * @param openFlag  启用状态 1.开启 0.关闭
   * @param auditFlag   获取场景 1.提交抖音审核 2.不提交
   * @param sendBackPolicyStatus 0：退款不需要退还赠品 1：需要退还赠品
   * @param sendBackPolicyDesc 退款策略描述
   * @param goodGiveEntityDetailList 详情内容 images图片   title标题
   * @returns {*}
   */
  saveGiveEntityDetail({ commit }, info) {
    return new Promise((resolve, reject) => {
      saveGiveEntityDetail(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 修改赠品发货状态
   * @param sendStatus 	1.已发货 0.未发货
   * @param id 键值id
   * @returns {AxiosPromise}
   */

  modifyOrderGiveEntitySendStatus({ commit }, info) {
    return new Promise((resolve, reject) => {
      modifyOrderGiveEntitySendStatus(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 修改赠品发货状态
   * @param sendStatus 	1.已发货 0.未发货
   * @param id 键值id
   * @returns {AxiosPromise}
   */
  modifyOrderGiveEntitySendByExcel({ commit }, info) {
    return new Promise((resolve, reject) => {
      modifyOrderGiveEntitySendByExcel(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },



}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
